<template>
    <div>
        <div class="Servic hs">
            <p>设计师风采</p>
        </div>
        <ul class="nrk work">
            <li v-for="item in Stylist.data" :key="item.id" @click="Details(item)">
                <div class="nmkimg">
                    <img :src="Http+item.logo">
                </div>
                <span>{{item.name}}</span>
            </li>
        </ul>
        <Pagination 
        :pageNo="date.page" 
        :pageSize='date.limit' 
        :total="Stylist.total" 
        :continues="5"
        @getPageNo='getPageNo'
        />
    </div>
</template>

<script>
 import{mapState} from'vuex';
export default {
    data() {
        return {
            date:{
                limit:9,
                page:1,
            }
        }
    },
    activated() {
        this.postNews(this.date)
    },
    computed:{
        ...mapState({
            Stylist:state=>state.share.Stylist,
            Http:state=>state.share.Http,
        })
    },
    methods: {
        Details(id){
            localStorage.setItem('Lawyer',JSON.stringify(id))
            this.$router.push({
                name:'DesignerDetails',
            })
        },
        getPageNo(id){
            this.date.page=id
            this.postNews(this.date)
        },
        postNews(naml){
            this.$store.dispatch('PostStylist',naml);
        }
    },
}
</script>

<style scoped>
    .work{
        overflow: hidden;
        margin: 20px auto;
        padding: 1%;
    }
    .work li{
        width: 18%;
        float: left;
        background-color: #eee;
        margin-right: 2.4%;
        cursor: pointer;
        margin-bottom: 30px;
        overflow: hidden;
        box-shadow: 0px 0px 8px #d9d9d9;

    }
    .work li:nth-child(5n){
        margin-right: 0;
    }
    .work li .nmkimg{
        height: 300px;
        overflow: hidden;
    }
    .work li img{
        width: 100%;
        height: 300px;
    }
    .work li:hover img {
        transform: scale(1.1);
        transition: all 0.5s ease;
    } 
    .work li span{
        text-align: center;
        display: block;
        margin: 20px 0;
        font-size: 18px;
        color: #164db2;
    }
    .work li:hover{
        background-color: #164db2;
    }
    .work li:hover span{
        color: #fff;
    }
    @media (max-width: 768px){
        .work li{
            width: 100%;
        }
        .work li .nmkimg,.work li img{
            height: auto;
        }
    }
</style>